export const Switcher = {
    template: `
        <div class="popups-info__desc" id="form_auth_email_desc">
            <!--<div class="popups-info__switch">
                <div v-bind:class="{'button': true, 'small': true, 'gray': true, 'active': this.$store.state.mode === 'phone'}" @click="$emit('togglePhone')">
                    {{ this.$store.state.messages.byPhone }}
                </div>
                <div v-bind:class="{'button': true, 'small': true, 'gray': true, 'active': this.$store.state.mode === 'email'}" @click="$emit('toggleEmail')">
                    {{ this.$store.state.messages.byEmail }}
                </div>
            </div>-->
            <div class="popups-info__text" v-if="this.$store.state.step === 'initial'">
                <span v-if="this.$store.state.mode === 'email'" v-html="this.$store.state.messages.descriptionEmail"></span>
                <span v-if="this.$store.state.mode === 'phone'" v-html="this.$store.state.messages.descriptionPhone"></span>
            </div>
        </div>
        <div class="popups-info__back svg-icon" v-if="this.$store.state.step === 'code'" @click="$emit('setInitialStep')">
            <svg width="26" height="16" viewBox="0 0 26 16" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                        d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM26 7L1 7V9L26 9V7Z"
                        fill="black"></path>
            </svg>
        </div>
    `
}
